import { Conversation, ConversationStatus } from 'generated-graphql/types';

export const isOngoingConversationInList = (conversations: Conversation[]) =>
  conversations.some(
    (conversation) => conversation.status === ConversationStatus.Ongoing
  );
